//Create namespace for this stuff
var ctrlopt = ctrlopt || {};

(function(window, document){
  "use strict";

  /**
   * Object.create is a polyfill to supply ECMAScript 5 functionality
   * @param {Object} proto
   * @param {Object} [descriptors=null] Optional object with property descriptors. See ECMAScript 5 Object.create for more detail.
   *                                    This does not supply full functionality but will take the property names and values to maintain
   *                                    that backward compatibility.
   *
   * @return {Object} The new object which uses the proto object passed as first param
   */

  if (typeof Object.create !== 'function') {
    Object.create = function (proto, descriptors) {
      //console.log('using me');
      function F() {}

      F.prototype = proto;
      var f = new F();
      for (var prop in descriptors) {
        if (!f[prop] && descriptors.hasOwnProperty(prop)) {
          f[prop] = descriptors[prop].value;
        }
      }
      return f;
    };
  }


  if (!Function.prototype.bind) {
    Function.prototype.bind = function (oThis) {
      if (typeof this !== "function") {
        // closest thing possible to the ECMAScript 5 internal IsCallable function
        throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
      }

      var aArgs = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP = function () {},
        fBound = function () {
          return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
        };

      fNOP.prototype = this.prototype;
      fBound.prototype = new fNOP();

      return fBound;
    };
  }


  ctrlopt.bind = function (f, context/*, args*/) {
    if (typeof f !== 'function') {
      throw new Error("CtrlOpt.bind requires the first argument to be a function");
    }
    /*if (typeof context !== 'object') {
     throw new Error("CtrlOpt.bind requires the second argument to be an object");
     }*/
    var args = [];
    for (var i = 2, len = arguments.length; i < len; i++) {
      args.push(arguments[i]);
    }

    return (function () {
      if (arguments.length > 0) {
        args = [];
        for (var j = 0, length = arguments.length; j < length; j++) {
          args.push(arguments[j]);
        }
      }
      f.apply(context, args);
    });
  };

  /**
   * A method that tells if an object is a DOM element
   * @param o  The object to test
   * @return {Boolean} returns true if o is a DOM element, false if not
   *
   */
  ctrlopt.isDOMElement = function (o) {
    try {
      //Using W3 DOM2 (works for FF, Opera and Chrome)
      o instanceof HTMLElement;
    }
    catch(e){
      //Browsers not supporting W3 DOM2 don't have HTMLElement and
      //an exception is thrown and we end up here. Testing some
      //properties that all elements have. (works on IE7)
      // memoize the non Dom way to avoid testing overhead in future
      ctrlopt.isDOMElement = function (o) {
        return (o && typeof o === "object" && o.nodeType && o.nodeType === 1 && typeof o.nodeName === "string");
      };

      return ctrlopt.isDOMElement(o);
    }
    // If we get here the DOM2 way worked
    // memoize the Dom2 way to avoid testing overhead in future
    ctrlopt.isDOMElement = function (o) {
      return o instanceof HTMLElement;
    };

    return ctrlopt.isDOMElement(o);
  };


  /**
   * A method that tells if an object is a DOM Node
   * @param o  The object to test
   * @return {Boolean} returns true if o is a DOM Node, false if not
   *
   */
  ctrlopt.isDOMNode = function (o) {
    try {
      //Using W3 DOM2 (works for FF, Opera and Chrome)
      o instanceof Node;
    }
    catch(e){
      //Browsers not supporting W3 DOM2 don't have Node and
      //an exception is thrown and we end up here. Testing some
      //properties that all elements have. (works on IE7)
      // memoize the non Dom way to avoid testing overhead in future
      ctrlopt.isDOMNode = function (o) {
        return (o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName==="string");
      };

      return ctrlopt.isDOMNode(o);
    }
    // If we get here the DOM2 way worked
    // memoize the Dom2 way to avoid testing overhead in future
    ctrlopt.isDOMNode = function (o) {
      return o instanceof Node;
    };

    return ctrlopt.isDOMNode(o);
  };

  /**
   * Interface Class Constructor.
   * mimics the functionality of a Classical language's interface
   * allows us to specify a set of method names and then use duck typing to
   * ensure a class or object implements those methods.
   * @param {String} name A string that is the interface name.
   * @param {String[]} methods Method names.
   **/

  ctrlopt.Interface = function (name, methods) {
    if (arguments.length !== 2) {
      throw new Error("Interface constructor expects exactly 2 arguments. It was called with " + arguments.length +
        " arguments");
    }
    if (typeof name !== 'string' || methods.constructor !== Array) {
      throw new TypeError();
    }
    this.name = name;
    this.methods = [];
    for (var i = 0, len = methods.length; i < len; i++) {
      var m = methods[i];
      if (typeof m !== 'string') {
        throw new Error("Interface constructor expects method names to be passed in as strings. Method name number " +
          (i + 1) + " is not a string");
      }
      this.methods.push(m);
    }
  };

  /**
   * Interface Class Constructor.
   * mimics the functionality of a Classical language's interface
   * allows us to specify a set of method names and then use duck typing to
   * ensure a class or object implements those methods.
   * @param {String} name A string that is the interface name.
   * @param {String[]} methods Method names.
   **/

  ctrlopt.Interface = function (name, methods) {
    if (arguments.length !== 2) {
      throw new Error("Interface constructor expects exactly 2 arguments. It was called with " + arguments.length +
      " arguments");
    }
    if (typeof name !== 'string' || methods.constructor !== Array) {
      throw new TypeError();
    }
    this.name = name;
    this.methods = [];
    for (var i = 0, len = methods.length; i < len; i++) {
      var m = methods[i];
      if (typeof m !== 'string') {
        throw new Error("Interface constructor expects method names to be passed in as strings. Method name number " +
        (i + 1) + " is not a string");
      }
      this.methods.push(m);
    }
  };

  /**
   * Interface static methods for handling duck typing
   * Interface.ensureImplements checks an object for methods
   * to ensure it implements the specified interfaces.
   * If an object fails this test an error is thrown, if it passes it does so silently.
   *
   * @param {Object} object The object we are testing to ensure it implements a specified interface.
   * @param {ctrlopt.Interface} interfaceToCheck The interface to test against
   * @param {ctrlopt.Interface} interfaceToCheck Additional optional interfaces can be specified in
   *                                      additional arguments, just add them on.
   *
   * @throws {Error} If the object does not implement a method of the supplied Interface(s).
   **/

  ctrlopt.Interface.ensureImplements = function (object, interfaceToCheck) {
    if (arguments.length < 2) {
      throw new Error("Function ctrlopt.Interface.ensureImplements requires at least 2 arguments, but was called with " +
      arguments.length);
    }
    for (var i = 1, len = arguments.length; i < len; i++) {
      var methods,
        iface = arguments[i];
      if (iface.constructor !== ctrlopt.Interface) {
        throw new Error("Function Interface.ensureImplements expects arguments 2 and above to be instances of " +
        "ctrlopt.Interface. Argument number " + (i + 1) + "was not");
      }
      methods = iface.methods;
      for (var j = 0, mLen = methods.length; j < mLen; j++) {
        var m = methods[j];
        if (!object[m] || typeof object[m] !== 'function') {
          throw new Error("Function Interface.ensureImplements: object does not implement the " + iface.name +
          " interface. The method " + m + " was not found.");
        }
      }
    }
  };

  /**
   * The extend function simplifies JavaScripts odd simulation of classical inheritance by encapsulating the steps.
   * For pure prototypal inheritance use the Object.create function instead.
   * @param {Function} descendant The constructor function that is inheriting
   * @param {Function|Object} ancestor The constructor function or object we are inheriting from
   */
  ctrlopt.extend = function (descendant, ancestor) {
    if (typeof descendant !== 'function') {
      throw new TypeError();
    }
    var aIsFunc = typeof ancestor === 'function',
      F = function () {};
    F.prototype = (aIsFunc) ? ancestor.prototype : ancestor;
    descendant.prototype = new F();
    descendant.prototype.constructor = descendant;
    descendant.superclass = (aIsFunc) ? ancestor.prototype : ancestor;
    if (aIsFunc && ancestor.prototype.constructor === Object.prototype.constructor) {
      ancestor.prototype.constructor = ancestor;
    }
  };


  /* Takes a string representing the href attribute and returns the query params in an object like so:
   {key: value, ... }
   */

  ctrlopt.getHrefParams = function (href) {
    var pair, splits,
      pairs = {},
      q = href.lastIndexOf('?');

    if (q !== -1 && q !== href.length - 1) {
      splits = href.slice(q + 1).split('&');
      for (var i = 0, l = splits.length; i < l; i++) {
        pair = splits[i].split('=');
        pairs[pair[0]] = pair[1];
      }
    }
    return pairs;
  };


  /**
   * Design pattern implementations
   **/

  ctrlopt.abstractMethod = function () {
    throw new Error("Abstract Method has been called. Please call this method on a concrete implementation.");
  };



  ctrlopt.iPublisher = new ctrlopt.Interface('ctrlopt.iPublisher',
    [
      'on',
      'off',
      'fire',
      'has',
      'indexOf',
      'destroy'
    ]
  );


  ctrlopt.Publisher = function () {
    this.subscribers = {};
  };
  ctrlopt.Publisher.prototype = {
    on: function (type, func, context) {
      if (typeof this.subscribers[type] === 'undefined') {
        this.subscribers[type] = [];
      }

      if (!this.has(type, func, context)) {
        this.subscribers[type].push({
          func: func,
          context: context || this
        });
      }
      return this;
    },

    off: function (type, func, context) {
      var i = this.indexOf(type, func, context);
      if (i > -1) {
        this.subscribers[type].splice(i, 1);
      }
      return this;
    },

    fire: function (type, data) {
      var subs;
      if (this.has(type)) {
        subs = this.subscribers[type].slice(0);
        for (var i = 0, len = subs.length; i < len; i++) {
          var o = subs[i];
          o.func.call(o.context, data);
        }
      }
      return this;
    },

    has: function (type, func, context) {
      if (!type) {
        throw new Error("A publisher's has method requires a type argument to check for");
      }
      if (typeof this.subscribers[type] !== 'undefined') {
        if (arguments.length === 1) {
          return true;
        }
        if (this.indexOf(type, func, context) > -1) {
          return true;
        }
      }
      return false;
    },

    indexOf: function (type, func, context) {
      context = context || this;
      if (type && typeof this.subscribers[type] !== 'undefined') {
        for (var i = 0, len = this.subscribers[type].length; i < len; i++) {
          var o = this.subscribers[type][i];
          if (o.func === func && o.context === context) {
            return i;
          }
        }
      }
      return -1;
    },

    destroy: function () {
      this.subscribers = null;
      return this;
    }
  };





  /**
   * An implementation of an Model View Controller design pattern
   * Requires the ctrlopt.ObservablePublisher class
   *
   */
  ctrlopt.mvc = {};

  /*
   *
   */
  ctrlopt.mvc.iModel = new ctrlopt.Interface('iModel', ['update', 'getData']);

  ctrlopt.mvc.iView = new ctrlopt.Interface('iView',
    [
      'setModel',
      'getModel',
      'setController',
      'getController',
      'defaultController',
      'startObserving',
      'stopObserving',
      'isObserving',
      'onUpdate',
      'destroy'
    ]
  );

  ctrlopt.mvc.iController = new ctrlopt.Interface('iController',
    [
      'setModel',
      'getModel',
      'setView',
      'getView',
      'destroy'
    ]
  );

  ctrlopt.mvc.AbstractView = function () {
    this.model = undefined;
    this.controller = undefined;
  };

  ctrlopt.mvc.AbstractView.prototype = {
    setModel: function (m) {
      if (!m) {
        throw new TypeError();
      }
      if(typeof this.model !== 'undefined') {
        this.stopObserving();
      }

      ctrlopt.Interface.ensureImplements(m, ctrlopt.mvc.iModel, ctrlopt.iPublisher);
      this.model = m;
      return this;
    },

    getModel: function () {
      ctrlopt.Interface.ensureImplements(this.model, ctrlopt.mvc.iModel, ctrlopt.iPublisher);
      return this.model;
    },

    setController: function (c) {
      if (c) {
        ctrlopt.Interface.ensureImplements(c, ctrlopt.mvc.iController);
      }
      this.controller = c;
      return this;
    },

    getController: function () {
      if (this.controller === undefined) {
        this.controller = this.defaultController();
      }
      if (this.controller) {
        ctrlopt.Interface.ensureImplements(this.controller, ctrlopt.mvc.iController);
      }
      return this.controller;
    },

    defaultController: ctrlopt.abstractMethod,

    startObserving: function () {
      if (!this.model) {
        return;
      }
      this.model.on('update', this.onUpdate, this);
      return this;
    },

    stopObserving: function () {
      if (!this.model) {
        return;
      }
      this.model.off('update', this.onUpdate, this);
      return this;
    },

    isObserving: function () {
      return this.model.has('update', this.onUpdate, this);
    },

    onUpdate: ctrlopt.abstractMethod,

    destroy: function () {
      //console.log('AbstractView.prototype.destroy called');
      this.stopObserving();
      this.model = undefined;
      //TODO - figure out a better way to destroy controller - sometimes when views share a controller this creates problems
      if(this.controller) {
        this.controller.destroy();
      }
      this.controller = undefined;
      return this;
    }
  };

  ctrlopt.mvc.AbstractController = function () {
    this.model = undefined;
    this.view = undefined;
  };

  ctrlopt.mvc.AbstractController.prototype = {
    setModel: function (m) {
      if (!m) {
        throw new TypeError();
      }
      if(typeof this.model !== 'undefined') {
        this.stopObserving();
      }

      ctrlopt.Interface.ensureImplements(m, ctrlopt.mvc.iModel, ctrlopt.iPublisher);
      this.model = m;
      return this;
    },

    getModel: function () {
      ctrlopt.Interface.ensureImplements(this.model, ctrlopt.mvc.iModel, ctrlopt.iPublisher);
      return this.model;
    },

    setView: function (v) {
      if (!v) {
        throw new TypeError();
      }
      ctrlopt.Interface.ensureImplements(v, ctrlopt.mvc.iView);
      this.view = v;
      return this;
    },

    getView: function () {
      return this.view;
    },

    startObserving: function () {
      if (!this.model) {
        return;
      }
      this.model.on('update', this.onUpdate, this);
      return this;
    },

    stopObserving: function () {
      if (!this.model) {
        return;
      }
      this.model.off('update', this.onUpdate, this);
      return this;
    },

    isObserving: function () {
      return this.model.has('update', this.onUpdate, this);
    },

    onUpdate: ctrlopt.abstractMethod,

    destroy: function () {
      //console.log('AbstractController.prototype.destroy called');

      this.model = undefined;
      this.view = undefined;
      return this;
    }
  };


  /**
   * ImgPreloader is a class that can be used to preload images
   * @param options Object
   *     @member elementId String optional        set the preloader container DOM  element. If the id of an existing element
   *                                                 is passed in that element becomes the container for the preloader.
   *                                                 Style the element with CSS to move it off screen.
   *     @member elementClass String  optional    Give the container element a class to style against.
   * @constructor
   */
  ctrlopt.ImgPreloader = function (options) {
    ctrlopt.ImgPreloader.superclass.constructor.call(this);

    var elId = options.elementId || 'img-preloader',
      elClass = options.elementClass,
      el = document.getElementById(elId);

    // Set up public vars for the event types
    this.LOADED = 'loaded';
    this.ERROR = 'error';

    //Set up the preloader element
    //We add the images to the page to truly load them. This forces
    //Older versions of IE to truly load the images and fire the onload
    //event even if the images are cached.
    if (!el) {
      el = document.createElement('div');
      el.id = elId;
      if (elClass) {
        el.className = elClass;
      }
      document.body.appendChild(el);
    } else {
      if(elClass) {
        el.className += (' ' + elClass);
      }
    }

    this.element = el;
  };

  ctrlopt.extend(ctrlopt.ImgPreloader, ctrlopt.Publisher);

  /**
   * ImgPreloader.load takes an array of Image src attribute paths, or a single path and adds it to the preloader container.
   * After all images have loaded it fires a LOADED event or and ERROR event.
   *
   * @param images String or Array of Strings     The paths of the images to load. These become the src attributes for the
   *                                                 images that get preloaded.
   *
   */
  ctrlopt.ImgPreloader.prototype.load = function (images) {
    if (!images) {
      throw new TypeError();
    }

    var loadCount = 0,
      me = this;

    images = (images instanceof Array) ? images : [images];

    function onLoad (e) {
      loadCount++;
      if(loadCount >= images.length) {
        me.fire(me.LOADED);
      }
    }

    function onError (e) {
      console.log ('ctrlopt.ImgPreloader Error: ' + e);
      me.fire(me.ERROR, e);
    }

    for (var i = images.length; --i >= 0; ) {
      var img = new Image();
      img.onload = onLoad;
      img.onerror = onError;
      img.src = images[i];
      this.element.appendChild(img);
    }
  };

  ctrlopt.ImgPreloader.prototype.clear = function () {
    this.element.innerHTML = '';
  };
}(window, document));